export const ECONOMY = 'economy'
export const PRIORITY = 'priority'
